module.exports = (__parcel__import__("./" + require('./helpers/bundle-manifest').resolve("h8HT2"))).then(() => parcelRequire('aCT3R'));